<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
        <CCard>
          <CCardBody>
            <CButton color="success" @click="createBatch()" class="mb-4"
              ><CIcon name="cil-plus" height="48" />{{ $t("Batch.AddBatch") }}</CButton
            >
            <CAlert :show.sync="dismissCountDown" color="primary" fade>
              ({{ dismissCountDown }}) {{ message }}
            </CAlert>
            <CDataTable
              hover
              :items="items"
              :fields="fields"
              :items-per-page="10"
              pagination
              columnFilter
              tableFilter
              sorter
            >
              <template #author="{item}">
                <td>
                  <strong>{{ item.reference }}</strong>
                </td>
              </template>
              <template #type="{item}">
                <td>
                  <strong>{{ item.type }}</strong>
                </td>
              </template>
              <template #provider="{item}">
                <td>
                  {{ item.provider }}
                </td>
              </template>
              <template #price="{item}">
                <td>
                  <strong>{{ item.price }} DT</strong>
                </td>
              </template>
              <template #Options="{item}">
                <td class="text-right">
                  <!-- <CButton
                    color="primary"
                    @click="showNote(item.id)"
                    class="mr-2"
                    ><CIcon name="cil-center-focus" height="48" />
                  </CButton> -->
                  <CButton
                    color="warning"
                    @click="updateBatch(item.id)"
                    class="mr-2"
                    ><CIcon name="cil-pencil" height="48" />
                  </CButton>
                  <CButton
                    v-if="you != item.id"
                    color="danger"
                    @click="deleteBatch(item.id)"
                    ><CIcon name="cil-trash" height="48" />
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import { batchService } from "../../_services";

export default {
  name: "Notes",
  data: () => {
    return {
      items: [],
      /*
      fields: [
        {key: 'author'},
        {key: 'title'},
        {key: 'content'},
        {key: 'applies_to_date'},
        {key: 'status'},
        {key: 'note_type'},
        {key: 'show'},
        {key: 'edit'},
        {key: 'delete'}
      ],
      */
      fields: [
        { key: "reference", label: "Référence" },
        { key: "type", label: "Type" },
        { key: "provider", label: "Fournisseur" },
        { key: "price", label: "Prix" },
        { key: "Options", label: "Options" },
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: "",
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
    };
  },
  computed: {},
  methods: {
    getRowCount(items) {
      return items.length;
    },
    noteLink(id) {
      return `notes/${id.toString()}`;
    },
    editLink(id) {
      return `batches/${id.toString()}/update`;
    },
    showNote(id) {
      const noteLink = this.noteLink(id);
      this.$router.push({ path: noteLink });
    },
    updateBatch(id) {
      const editLink = this.editLink(id);
      this.$router.push({ path: editLink });
    },
    deleteBatch(id) {
      this.loader = this.$loading.show();
      batchService
        .delete(id)
        .then(
          function() {
            this.message = "deleted successfully";
            this.showAlert();
            this.$router.go();
          }.bind(this)
        )
        .finally(
          function() {
            this.loader.hide();
          }.bind(this)
        );
    },
    createBatch() {
      this.$router.push({ path: "batches/create" });
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    getNotes() {
      let self = this;
      this.loader = this.$loading.show();
      batchService
        .getAll()
        .then(function(response) {
          self.items = response.data;
        })
        .finally(
          function() {
            this.loader.hide();
          }.bind(this)
        );
    },
  },
  mounted: function() {
    this.getNotes();
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
